"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.functionalColors = functionalColors;
exports.kualiColors = exports.colors = exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var values = {
  brand: '#008EE2',
  electric: '#008EE2',
  shamrock: '#00AC18',
  barney: '#BF32A4',
  crimson: '#EE0612',
  fire: '#FC5E13',
  licorice: '#2D3B45',
  oxford: '#394B58',
  ash: '#8B969E',
  slate: '#8B969E',
  tiara: '#C7CDD1',
  porcelain: '#F5F5F5',
  white: '#FFFFFF'
};
var kualiColors = {
  primary: '#111111',
  secondary: '#666666',
  link: '#0066CC',
  white: '#FFFFFF',
  blue500: '#346BA7',
  blue400: '#468DCB',
  blue300: '#61A8DD',
  blue200: '#9BCCEB',
  blue100: '#E5F2F9',
  green500: '#186704',
  green400: '#49AA30',
  green300: '#6cc459',
  green200: '#aadc9f',
  green100: '#e9f6e7',
  orange500: '#C54700',
  orange400: '#ef6c05',
  orange300: '#ffa628',
  orange200: '#ffcb80',
  orange100: '#fff3e0',
  red500: '#b61b1c',
  red400: '#d22e2f',
  red300: '#ee5250',
  red200: '#ee9a9a',
  red100: '#ffebee',
  wintergreen500: '#005640',
  wintergreen400: '#008461',
  wintergreen300: '#00B586',
  wintergreen200: '#72DDC1',
  wintergreen100: '#E3F8F3',
  aqua500: '#306167',
  aqua400: '#4CAEC3',
  aqua300: '#57C7DE',
  aqua200: '#8EDFEE',
  aqua100: '#E3F7FB',
  purple500: '#3E2789',
  purple400: '#543599',
  purple300: '#7456AA',
  purple200: '#AC9BCD',
  purple100: '#EBE6F2',
  magma500: '#8E0076',
  magma400: '#AE0083',
  magma300: '#C83397',
  magma200: '#E28DC0',
  magma100: '#F8E4EF',
  yellow500: '#F6A411',
  yellow400: '#F7BD1B',
  yellow300: '#F6E426',
  yellow200: '#FBEE6F',
  yellow100: '#FDF8C1',
  darkGray500: '#111111',
  darkGray400: '#222222',
  darkGray300: '#333333',
  darkGray200: '#444444',
  darkGray100: '#555555',
  mediumGray500: '#666666',
  mediumGray400: '#777777',
  mediumGray300: '#888888',
  mediumGray200: '#999999',
  mediumGray100: '#AAAAAA',
  lightGray500: '#BBBBBB',
  lightGray400: '#CCCCCC',
  lightGray300: '#DDDDDD',
  lightGray200: '#EEEEEE',
  lightGray100: '#F7F7F7',
  darkCool500: '#222A30',
  darkCool400: '#333F47',
  darkCool300: '#41515C',
  darkCool200: '#506572',
  darkCool100: '#5C7382',
  lightCool500: '#8D9CA7',
  lightCool400: '#AEB8BF',
  lightCool300: '#CED4D8',
  lightCool200: '#ECEDEE',
  lightCool100: '#F9FAFB'
};
exports.kualiColors = kualiColors;

function functionalColors(colors) {
  return (0, _objectSpread2.default)({}, colors, {}, kualiColors, {
    textDarkest: '#111111',
    textDark: '#666666',
    textLight: '#0066CC',
    textLightest: '#FFFFFF',
    textPrimary: '#111111',
    textSecondary: '#666666',
    textLink: '#0066CC',
    textWhite: '#FFFFFF',
    textBrand: colors.brand,
    textAlert: colors.barney,
    textInfo: colors.brand,
    textSuccess: colors.shamrock,
    textDanger: colors.crimson,
    textWarning: colors.fire,
    backgroundDarkest: colors.licorice,
    backgroundDark: colors.ash,
    backgroundMedium: colors.tiara,
    backgroundLight: colors.porcelain,
    backgroundLightest: colors.white,
    backgroundBrand: colors.brand,
    backgroundBrandSecondary: colors.oxford,
    backgroundAlert: colors.barney,
    backgroundInfo: colors.brand,
    backgroundSuccess: colors.shamrock,
    backgroundDanger: colors.crimson,
    backgroundWarning: colors.fire,
    borderLightest: colors.white,
    borderLight: colors.porcelain,
    borderMedium: colors.tiara,
    borderDark: colors.ash,
    borderDarkest: colors.licorice,
    borderBrand: colors.brand,
    borderAlert: colors.barney,
    borderInfo: kualiColors.blue300,
    borderSuccess: colors.shamrock,
    borderDanger: colors.crimson,
    borderWarning: colors.fire,
    borderDebug: colors.crimson
  });
}

var colors = Object.freeze(functionalColors(values));
exports.colors = colors;
var _default = colors;
exports.default = _default;